import React from 'react'
import intl from 'react-intl-universal'
import PropTypes from 'prop-types'
import { Checked } from './Checked'

import './styles.scss'

export const HyperlinkConfig = ({
  companySettings,
  handleHyperlinkConfigSettings,
}) => {
  const [settings, setSettings] = React.useState({
    openNewTabByDefault: false,
    noFollowByDefault: false,
    sponsoredByDefault: false,
    noStrictHttpsByDefault: false,
    autoLink: false,
  })

  const settingHandler = (prop) => {
    setSettings((prev) => {
      return { ...prev, [prop]: !prev[prop] }
    })
  }

  React.useEffect(() => {
    if (companySettings) {
      setSettings({
        openNewTabByDefault: Boolean(
          companySettings?.hyperlink?.openNewTabByDefault
        ),
        noFollowByDefault: Boolean(
          companySettings?.hyperlink?.noFollowByDefault
        ),
        sponsoredByDefault: Boolean(
          companySettings?.hyperlink?.sponsoredByDefault
        ),
        noStrictHttpsByDefault: Boolean(
          companySettings?.hyperlink?.noStrictHttpsByDefault
        ),
        autoLink: Boolean(companySettings?.hyperlink?.autoLink),
      })
    }
  }, [companySettings])

  React.useEffect(() => {
    handleHyperlinkConfigSettings(settings)
  }, [settings, handleHyperlinkConfigSettings])

  return (
    <div
      className="card mb-2"
      data-testid="composer-settings--hyperlink-defaults"
    >
      <h2 className="card-header">
        {intl.get('settings.hyperlinkDefaults.header')}
      </h2>
      <div className="card-block">
        <div>{intl.getHTML('settings.hyperlinkDefaults.description')}</div>
        <Checked
          label={intl.get('settings.hyperlinkDefaults.openNewTabByDefault')}
          value={settings.openNewTabByDefault}
          handler={() => settingHandler('openNewTabByDefault')}
          id="composer-settings--open-new-tab-by-default"
        />
        <Checked
          label={intl.getHTML('settings.hyperlinkDefaults.noFollowByDefault')}
          value={settings.noFollowByDefault}
          handler={() => settingHandler('noFollowByDefault')}
          id="composer-settings--no-follow-by-default"
        />
        <Checked
          label={intl.getHTML('settings.hyperlinkDefaults.sponsoredByDefault')}
          value={settings.sponsoredByDefault}
          handler={() => settingHandler('sponsoredByDefault')}
          id="composer-settings--sponsored-by-default"
        />
        <Checked
          label={intl.get('settings.hyperlinkDefaults.noStrictHttpsByDefault')}
          value={settings.noStrictHttpsByDefault}
          handler={() => settingHandler('noStrictHttpsByDefault')}
          id="composer-settings--no-strict-https-by-default"
        />
        <Checked
          label={intl.get('settings.hyperlinkDefaults.autoLink')}
          value={settings.autoLink}
          handler={() => settingHandler('autoLink')}
          id="composer-settings--autoLink"
        />
      </div>
    </div>
  )
}

HyperlinkConfig.propTypes = {
  companySettings: PropTypes.object,
  handleHyperlinkConfigSettings: PropTypes.func,
}
